export default {
	namespaced: true,
	state: {
		
		errors: [],
		error: undefined
	},

	getters: {
		errors(state)
		{
			return state.errors
		},

		error(state)
		{
			return state.error;
		},

		hasErrors(state)
		{
			return state.errors.length > 0;
		},
		hasError(state)
		{
			return typeof state.error !== 'undefined';
		}
	},

	actions: {
		setErrors(context, payload)
		{
			context.commit('errors', payload);
		},

		setError(context, payload)
		{
			
			context.commit('error', payload)
		}
	},

	mutations: {
		errors(state, payload)
		{
			state.errors = payload;
		},

		error(state, payload)
		{
			state.error = payload;
		}
	}
}